import {
  RequerimentoOnlineConfiguracao,
  RequerimentoOnlineSalvo,
} from '../../models/parametros/requerimento-online.model';
import {
  RequerimentoDocumentoResponseDto,
  RequerimentoOnlineResponseDto,
  SalvarRequerimentoOnlineCommandDto,
} from '../../models/parametros/requerimento-online-api.model';
import { extractIsoDate, toApiDateTime } from '../../utils/date-format.util';

/**
 * Tipo ainda sem configuração no plano (`id` nulo) abre ativo, sem vigência, sem assinatura e sem
 * documentos; a última atualização só existe depois de salvar.
 */
export function requerimentoDtoToSalvo(dto: RequerimentoOnlineResponseDto): RequerimentoOnlineSalvo {
  const configurada = dto.id != null;
  return {
    idTipoRequerimento: dto.id_tp_reqr,
    configurada,
    ultimaAtualizacao: configurada && dto.dt_ult_atu ? dto.dt_ult_atu.replace(' ', 'T') : null,
    configuracao: {
      status: !configurada || dto.fl_ativo ? 'Ativo' : 'Inativo',
      vigencia: {
        inicio: extractIsoDate(dto.dt_ini_vigencia),
        fim: extractIsoDate(dto.dt_fim_vigencia) || null,
      },
      descricao: dto.ds_requerimento?.trim() ?? '',
      assinatura: {
        obrigatoria: dto.fl_exige_assin,
        provedor: dto.id_prov_assin == null ? '' : String(dto.id_prov_assin),
        validacaoDuasEtapas: dto.fl_valida_2_etapas,
      },
      documentos: (dto.documentos ?? []).map(documentoDtoToDocumento),
    },
  };
}

/** Provedor e validação em duas etapas só valem com assinatura; descrição vazia vai nula. */
export function configuracaoToSalvarRequerimentoCommand(
  configuracao: RequerimentoOnlineConfiguracao,
): SalvarRequerimentoOnlineCommandDto {
  const { assinatura, vigencia } = configuracao;
  return {
    fl_ativo: configuracao.status === 'Ativo',
    dt_ini_vigencia: toApiDateTime(vigencia.inicio),
    dt_fim_vigencia: vigencia.fim ? toApiDateTime(vigencia.fim) : null,
    ds_requerimento: configuracao.descricao.trim() || null,
    fl_exige_assin: assinatura.obrigatoria,
    id_prov_assin: assinatura.obrigatoria && assinatura.provedor ? Number(assinatura.provedor) : null,
    fl_valida_2_etapas: assinatura.obrigatoria && assinatura.validacaoDuasEtapas,
    id_documentos: configuracao.documentos.map((documento) => documento.id),
  };
}

/** O id na tela é o do tipo de documento; sem o resumo do catálogo, entra com nome genérico. */
function documentoDtoToDocumento(dto: RequerimentoDocumentoResponseDto) {
  const nome = (dto.documento_tipo?.nome_exibicao || dto.documento_tipo?.nome || '').trim();
  return { id: dto.id_doc_tipo, nome: nome || `Documento ${dto.id_doc_tipo}` };
}
